import { HttpErrorResponse } from '@angular/common/http';

export class ConflictError extends Error {
    httpStatus = 409;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, ConflictError.prototype);
    }
}
